var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1904 17.0932L27.0954 13.0896C26.9298 13.0299 26.7592 13 26.5857 13C26.4114 13 26.2383 13.0302 26.072 13.0905L15.0167 17.0941C14.4192 17.3108 14 17.8785 14 18.5142V28C14 30.1177 14.6826 32.2358 15.9853 34.2952C16.9838 35.8736 18.3735 37.4215 20.0943 38.8961C22.9716 41.3617 25.8264 42.7839 25.9464 42.8432C26.1575 42.9476 26.3897 43 26.6192 43C26.8453 43 27.0729 42.9492 27.2816 42.8477C27.4015 42.7893 30.2551 41.3893 33.135 38.9335C34.8575 37.4648 36.2265 35.9169 37.2257 34.333C38.5278 32.2692 39.1769 30.1385 39.1769 28V18.5142C39.177 17.8775 38.7893 17.3091 38.1904 17.0932ZM16.417 27.9929V19.6436C16.417 19.3258 16.6118 19.0419 16.9106 18.9335L26.3078 15.5148C26.3916 15.4845 26.4878 15.4621 26.5885 15.4621V28.0001H36.8316C36.8322 28.0001 36.8329 28.0136 36.8329 28.0223C36.8309 30.7544 35.4548 33.4621 32.7435 36.0986C30.6261 38.1576 28.2205 39.627 26.9831 40.3202C26.8684 40.3845 26.6893 40.4148 26.5886 40.4148C26.5886 40.1799 26.5886 28.1303 26.5886 27.9961L16.417 27.9929Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 52,
    height: 52,
    rx: 13.5,
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon2.88cd0b21.svg";
export { ForwardRef as ReactComponent };